export default "__VITE_ASSET__2105b1ed__"